module.exports = __webpack_public_path__ + "static/media/picture10@2x.b7242e6d.png";